export default "__VITE_ASSET__b8069829__"